<script lang="ts">
    import type {Option} from "./option";
    import type {TransitionConfig} from "svelte/transition";
    import {cubicInOut} from 'svelte/easing';

    export let label: string;
    export let value: number | null = null;
    export let options: Option[];
	export let showSearch = true;
    export let isPhoneSize = false;

    export let containerClasses: string = '';
    export let containerStyle: string = '';

    let btn: HTMLElement;
    let dropdown: HTMLElement;

    let searchValue = '';
    let filteredOptions: Option[];
    $: filteredOptions = (options || []).filter(o => o.label.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0);

    let expanded = false;

    function select(val: number) {
	    value = val;
	    searchValue = '';
	    expanded = false;
    }

    function onClick(e: Event) {
	    if (e.target === btn) {
		    expanded = !expanded;
	    } else if (!dropdown.contains(e.target as Node)) {
		    expanded = false;
	    }
    }

    function rotate(node: Element, params: { reverse?: boolean }): TransitionConfig {
	    return {
		    easing: cubicInOut,
		    duration: 200,
		    css: (t, u) => `transform: rotate(${(params.reverse ? u : t) * 180}deg)`
	    }
    }
</script>

<svelte:window on:click={onClick}/>

<div class="dropdown {containerClasses}"
     bind:this={dropdown}
     class:expanded={expanded === true}
     class:selected={value != null}
     style="{containerStyle}">
    <button bind:this={btn} class="custom-dropdown-toggle d-flex justify-content-between">
        {label}
        {#key expanded}
            <img class="my-auto" in:rotate={{reverse: !expanded}} alt="{expanded ? 'close' : 'open'} dropdown"
                 class:rotate180={expanded} src="./map/img/arrow_{expanded ? 'white' : 'orange'}.png">
        {/key}
    </button>
    <div class="dropdown-content" class:mobile={isPhoneSize}>
        {#if showSearch}
            <div class="search-container">
                <input bind:value={searchValue} class="search-input" type="text">
                <img on:click={() => searchValue = ''} class="search-clear" src="./map/img/clear.png" alt="clear input">
            </div>
        {/if}
        {#each filteredOptions as option}
            <span on:click={() => select(option.value)}>{option.label}</span>
        {/each}
    </div>
</div>

<style>
    /* Toggle */
    .custom-dropdown-toggle {
        /* Remove default styles */
        color: inherit;
        padding: 0.5rem;
        font: inherit;
        cursor: pointer;
        outline: inherit;

        border: 2px solid #FE6D50;
        background: white;
        text-align: left;
        width: 100%;
        margin-bottom: 0 !important;

        white-space: nowrap;
    }

    .expanded .custom-dropdown-toggle {
        background: #FE6D50;
        color: white;
    }

    /*.selected .custom-dropdown-toggle {*/
    /*    background: #FE6D50;*/
    /*}*/
    /* Search Bar */
    .search-container {
        display: flex;
        width: 100%;
        padding: 0.5rem;
        margin-bottom: 0 !important;
        border-bottom: 1px solid #949DAA;
    }

    .search-input {
        width: 100%;
        margin-bottom: 0 !important;
    }

    .search-clear {
        cursor: pointer;
        margin: auto 0 auto 0.5rem !important;
    }

    /* Dropdown styling */
    .dropdown {
        display: inline-block;
        position: relative;
    }

    .dropdown-content {
        display: none;
        position: absolute;
        width: 100%;
        overflow: auto;
        /*box-shadow: 0 10px 10px 0 rgba(0,0,0,0.4);*/
        background: white;

        border: 1px solid #949DAA;
        z-index: 9999;
    }
    .dropdown-content.mobile {
        width: 400%;
        max-width: 100vw;
    }

    .expanded .dropdown-content {
        display: block;
    }

    .dropdown-content > span {
        display: block;
        color: #000000;
        padding: 5px;
        text-decoration: none;

        overflow: hidden;
        text-overflow: ellipsis;

        cursor: pointer;
    }

    .dropdown-content > span:hover {
        color: #FFFFFF;
        background-color: #00A4BD;
    }

    .rotate180 {
        transform: rotate(180deg);
    }
</style>
